import {
    ensureUnauthenticatedUserSessionIdInCookie,
    getReport,
    takeObjectAndMakeBottomLevelDecimalValuesIntoFloats,
    logException,
} from '../../utils';

export const ActionTypes = {
    SET_REPORT_DATA: 'SET_REPORT_DATA'
};

export function getBarProfitReportById(id) {
    return function(dispatch, getState) {

        ensureUnauthenticatedUserSessionIdInCookie(function(sessionId) {
            getReport(sessionId, id, function(report) {

                const processedReport = takeObjectAndMakeBottomLevelDecimalValuesIntoFloats(report);

                const reportData = {
                    letterGrade: processedReport.letterGrade,
                    dataBySetName: {
                        averageSittingInventory: processedReport.averageSittingInventory,
                        annualSales: processedReport.annualSales,
                        inventoryWeeks: processedReport.inventoryWeeks,
                        pourCostPercent: processedReport.pourCostPercent,
                        weeklyUsage: processedReport.weeklyUsage,
                    },
                    analysisBySetName: {
                        inventoryWeeks: processedReport.inventoryWeeksAnalysis,
                        pourCostPercent: processedReport.pourCostPercentAnalysis,
                    }
                };

                dispatch({
                    type: ActionTypes.SET_REPORT_DATA,
                    data: {
                        ...reportData,
                        errorMessage: ""
                    },
                });

                // Hubspot
                $.post('/webhooks/hubspot/bar_profit_tool_report/', {
                    hubspot_cookie: Utils.getCookie('hubspotutk'),
                    report_grade: reportData.letterGrade,
                    report_url: location.href,
                    referrer: document.referrer,
                });
            }, function(exception, args) {
                logException('2080E348-51C3-4224-86AA-BDD054592B59', exception, args);
                throw exception;
            });
        });
    };
}